import { AxiosInstance } from 'axios';

import { cancellable } from '../cancellable';
import { toResponse } from '../genericToResponse';
import { IFormData } from 'src/views/LinkCreate/types';

export default (api: AxiosInstance, url: string) => (link: any) => {
  return cancellable<IFormData>(
    (cancelOptions: any) => api.post(url, link, cancelOptions),
    toResponse
  );
};



// WEBPACK FOOTER //
// ./src/services/api/link/validate.ts